import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/I0_German.svg"

const I0German: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 18 18'} component={Icon} {...props} fill="currentColor" />
export default I0German
